<template>
    <div id="baby-paradise">
        <div class="title">订单管理 > 亲子项目订单</div>
        <el-card class="main">
            <div class="query-form">
                <el-form :model="formInline" ref="ruleForm" label-width="100px">
                    <el-form-item label="用户名称：">
                        <el-input v-model="formInline.name" placeholder="用户ID/账号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态：">
                        <el-select v-model="formInline.status" placeholder="请选择">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="待支付" :value="1"></el-option>
                        <el-option label="待预约" :value="2"></el-option>
                        <el-option label="待使用" :value="3"></el-option>
                        <el-option label="待评价" :value="4"></el-option>
                        <el-option label="已取消" :value="5"></el-option>
                        <el-option label="已完成" :value="6"></el-option>
                        <el-option label="已关闭" :value="7"></el-option>
                        <el-option label="退款中" :value="8"></el-option>
                        <el-option label="退款成功" :value="9"></el-option>
                        <el-option label="退款失败" :value="10"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                        <el-button type="primary" @click="query">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="table">
                <el-table :data="tableData" style="width: 100%; min-height: 450px;" v-loading="loading">
                    <el-table-column prop="spu_name" label="景区名称"></el-table-column>
                    <el-table-column prop="name" label="用户名称"></el-table-column>
                    <el-table-column prop="phone" label="联系电话"></el-table-column>
                    <el-table-column prop="sku_name" label="门票名称"></el-table-column>
                    <el-table-column prop="scenic_spot" label="景区种类"></el-table-column>
                    <el-table-column prop="price_order" label="订单金额（元）"></el-table-column>
                    <el-table-column prop="order_status" label="订单状态">
                        <template slot-scope="{row}">
                            <span v-if="row.order_status == '待支付'||row.order_status == '待预约' || row.order_status == '待退款' || row.order_status == '待使用' || row.order_status == '待评价'" class="status-view">
                                <span class="circle-status" style="background-color: #E6A23C;"></span>
                                {{ row.order_status }}
                            </span>
                            <span v-if="row.order_status == '已取消' || row.order_status == '已关闭' || row.order_status == '已完成' || row.order_status == '退款中'" class="status-view">
                                <span class="circle-status" style="background-color: #67C23A;"></span>
                                {{ row.order_status }}
                            </span>
                            <span v-if="row.order_status == '退款失败'" class="status-view">
                                <span class="circle-status" style="background-color: #F56C6C;"></span>
                                {{ row.order_status }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="160">
                        <template slot-scope="{row}">
                            <el-link type="primary" @click="lookDetails(row)">详情</el-link>
                            <el-link type="warning" v-if="(row.order_status == 3 && row.order_refund == 1) || (row.order_status == 2 && row.order_refund == 1)" style="margin-left: 12px;" @click="onCheck(scope.row)">审核</el-link>
                            <el-link type="danger" v-if="row.order_refund == 3 || row.order_refund == 4" style="margin-left: 12px;" @click="lookFail(row)">失败原因</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-footer">
                    <el-pagination
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
                    </el-pagination>
                </div>
        </el-card>
        <el-dialog
            title="审核"
            :visible.sync="checkDialog"
            width="30%">
            <el-radio-group v-model="check">
                <el-radio :label="1">审核成功</el-radio>
                <el-radio :label="0">审核失败</el-radio>
            </el-radio-group>
            <template v-if="check==0">
                <el-input type="textarea" style="margin-top: 12px;" placeholder="输入失败原因" v-model="whyFail" maxlength="200" show-word-limit></el-input>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkDialog = false">取 消</el-button>
                <el-button type="primary" @click="onSure">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="失败原因"
            :visible.sync="failDialog"
            width="30%">
            <p>{{ whyFail }}</p>
        </el-dialog>
    </div>
</template>

<script>
import { getBabyOrderList, setBabyOrderOption } from '@/api/baby/order.js';
import { getAreaType } from '@/api/baby/ticket.js'
import { getShopStorage } from '@/utils/storage.js'
export default {
    data () {
        return {
            loading: false,
            formInline: {
                name: '',
                status: 0
            },
            data: [{}],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            check: 1,
            checkDialog: false,
            whyFail: '',
            failDialog: false,
            typeList: [],
            shop_opt: []
        }
    }, 
    computed: {
        tableData () {
            return this.data.map(item => {
                let scenic_spot = '景区';
                let index = this.typeList.findIndex(ty => {
                    return ty.id == item.scenic_spot
                })
                if (index > -1) {
                    scenic_spot = this.typeList[index].name
                }
                return {
                    ...item,
                    scenic_spot,
                    order_status: this.statusName(item.order_status, item.order_refund)
                }
            })
        }
    },
    methods: {
        statusName (k1, k2) {
            if (k2 == 0 || k2 == null) {
                switch (k1) {
                    case 1:
                    return '待支付'
                    case 2:
                    return '待预约'
                    case 3:
                    return '待使用'
                    case 4:
                    return '待评价'
                    case 5:
                    return '已取消'
                    case 6:
                    return '已完成'
                    case 7:
                    return '已关闭'
                }
            } else {
                if (k2 == 1) {
                    return '退款中'
                } else if (k2 == 2) {
                    // return '退款成功'
                    return '已完成'
                } else if (k2 == 3 || k2 == 4) {
                    return '退款失败'
                }
            }
        },
        handleSizeChange (page) {
            this.pageSize = page;
            this.initTable();
        },
        handleCurrentChange (page) {
            this.currentPage = page;
            this.initTable();
        },
        // 确定审核
        onSure () {
            let params = {
                order_sn: '',   // 订单单号
                options: this.check == 1 ? 1 : 2
            }
            if (this.check == 0) {
                params.refund_message = this.whyFail;
            }
            setBabyOrderOption(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.initTable();
                        this.checkDialog = false;
                        this.$message.success('已完成审核！')
                        this.whyFail = '';
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        },
        // 审核
        onCheck () {
            this.checkDialog = true;
        },
        lookFail (row) {
            this.whyFail = row.refund_msg;
            this.failDialog = true;
        },
        lookDetails (row) {
            let order_sn = row.order_sn;
            let scenic_spot = row.scenic_spot;
            this.$router.push({path: '/home/baby-paradise-details', query: { order_sn, scenic_spot }})
        },
        resetForm(formName) {
            this.formInline.status = 0;
            this.formInline.name = '';
            this.initTable();
            // this.$refs[formName].resetFields();
        },
        query () {
            this.initTable();
        },
        initTable () {
            let shop_id = this.shop_opt.map(sp => { return sp.shop_id })
            if (!shop_id.length) {
                return
            }
            let params = {
                shop_id: shop_id.join(','),
                name: this.formInline.name,
                status: this.formInline.status,
                page: this.currentPage,
                limit: this.pageSize
            }
            this.loading = true;
            getBabyOrderList(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data.data;
                        this.total = res.data.data.total;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        },
        getAreaType() {
            let params = {
                platform: 13
            }
            getAreaType(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.typeList = res.data.data.data;
                    } else {
                        this.$message.error(res.data.code);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        },
    },
    mounted () {
        if (getShopStorage()) {
            this.shop_opt = getShopStorage();
            this.initTable();
        } else {
            this.$confirm('您还没有自己的店铺哦，快去申请店铺吧！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                callback: action => {
                    if (action == 'confirm') {
                        this.$router.push({ path: "/home/shopManage" });
                    }
                }
            });
        }
        this.getAreaType();
    }
}
</script>

<style lang="scss" scoped>
    #baby-paradise {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
        }
        .main {
            margin: 24px 24px 12px;
            border-radius: 0;
        }
        .query-form {
            .el-form {
                display: flex;
                justify-content: space-between;
            }
        }
        .table {
            margin: 0px 24px 24px 24px;
        }
    }
    
    .table-footer {
        padding-right: 12px;
        display: flex;
        justify-content: flex-end;
    }

    ::v-deep .el-pagination {
        margin-top: 12px;
        display: inline-block;
    }

    ::v-deep .el-select {
        width: 100%;
    }

    ::v-deep .el-form-item {
        flex: 1;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }

    .cell {
        .status-view {
            display: flex;
            align-items: center;
            .circle-status {
                display: block;
                width: 15px;
                height: 15px;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
</style>